import { EuiSkeletonRectangle } from "@inscopix/ideas-eui";

/** Component that renders a cell value that is still loading */
export const CellValueRendererLoading = () => {
  return <EuiSkeletonRectangle width={178} height={20} borderRadius="s" />;
};
